export default {

    // LEADS
    ADD_LEAD: {
        url: "/api/v1/leads",
        method: "post",
    },
    GET_LEADS: {
        url: "/api/v1/leads",
        method: "get",
    },
    GET_LEADS_BY_STATUS: {
        url: "/api/v1/leads/status-counts",
        method: "get",
    },
    GET_LEAD_COUNT_BY_STATUS: {
        url: "/api/v1/leads/dashboard-count",
        method: "get",
    },
    EXPORT_LEADS: {
        url: "/api/v1/leads/export",
        method: "get",
    },
    GET_LEADS_ASSIGNED_BY_COUNTS: {
        url: "/api/v1/leads/assigned-by-counts",
        method: "get",
    },
    GET_LEADS_BY_ID: {
        url: "/api/v1/leads/{lead_id}",
        method: "get",
    },
    GET_LEADS_OVERALL_METRICS: {
        url: "/api/v1/leads/counts/{timeline}",
        method: "get",
    },
    EXPORT_LEADS_ASSIGNED_BY_ME: {
        url: "/api/v1/leads/export-assigned-by-me",
        method: "get",
    },
    GET_LEAD_DASHBOARD_INFO: {
        url: "/api/v1/leads/dashboard",
        method: "get",
    },
    UPDATE_LEAD: {
        url: "/api/v1/leads/{lead_id}",
        method: "put",
    },
    UPDATE_OPS_LEAD: {
        url: "/api/v1/leads/ops/{lead_id}",
        method: "put",
    },
    DELETE_LEAD: {
        url: "/api/v1/leads/{lead_id}",
        method: "delete",
    },
    DELETE_BULK_LEADS: {
        url: "/api/v1/leads/bulk-delete",
        method: "delete",
    },
    ASSIGN_DEPT_TO_LEAD: {
        url: "/api/v1/leads/assignment",
        method: "put",
    },
    ASSIGN_SINGLE_LEAD: {
        url: "/api/v1/leads/assignment/single/{lead_id}",
        method: "put",
    },
    GET_LEAD_HISTORY: {
        url: "/api/v1/assigned-lead-history",
        method: "get",
    },
    // BULK FILES
    BULK_UPLOAD_LEAD: {
        url: "/api/v1/leads/bulk-upload",
        method: "post",
    },
    DOWNLOAD_LEADS_TEMPLATE: {
        url: "/api/v1/leads/bulk-upload/template",
        method: "get",
    },
    DOWNLOAD_LEADS_LISTS: {
        url: "/api/v1/leads/bulk-download",
        method: "post",
    },
    REASSIGN_LEADS: {
        url: "/api/v1/leads/reassign",
        method: "post",
    },
}